module.exports = __webpack_public_path__ + "static/media/star-icon-outline.bb1605ca.svg";